import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const qualityFilesSlice = createApi({
    reducerPath: "qualityFiles",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://brand-logistics.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        qualityFiles: builder.mutation({
            query: (data) => ({ url: "/inventory/api/v1/qualitycheckdocument/create", method: "POST", body: data }),
        }),
    }),
});

export const { useQualityFilesMutation } = qualityFilesSlice;
